import type { FaireProductEntity } from "../../entity_types/product";

export const p_2qcw8mc5sn: FaireProductEntity = {
  token: "p_2qcw8mc5sn",
  type: "product",
  name: "Elderberry Syrup",
  brandToken: "b_c96vrxm17w",
  brandName: "Lavender Thorne",
  imageUrl:
    "https://cdn.faire.com/fastly/4fb516dd5c9a32c4b8a98a4f5c2ca2373871b8d646f9d99719336a0b047121b8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2b194a777c9bf2a361954f7a40fef0c216610a957eb48c5e895f65793a8f7cac.jpeg",
    "https://cdn.faire.com/fastly/1acd054eaef0cfd56745f417d29ed593cd5429f5826f15d17d80b84d13670df9.jpeg",
  ],
  priceDollars: 11,
  description:
    "Elderberry is an immune boosting berry known for being high in antioxidants and boosting overall health and wellness. Relieves sore throats, allergy symptoms, hangovers, cold and flu symptoms, inflammation, high cholesterol, blood pressure, and more! \n\nFor Adults: Take 1 TBSP daily to boost immunity. When symptomatic, take 1-2 TBSP every 3-4 hours as needed.\n\nFor Children (1 and up): Take 1 TSP daily to boost immunity. When symptomatic, take 1/2 TSP every 3-4 hours.  ",
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:48:35.657Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
